<div class="absolute inset-0 flex items-center justify-center bg-transparent">
  <mat-spinner color="primary" [diameter]="30" [strokeWidth]="3"></mat-spinner>
</div>
